import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { getDropTreeValue, getFieldValue, ScIconPipe } from '@core/jss-utils';
import type { ImageField } from '@sitecore-jss/sitecore-jss-angular';
import {
  ImageCardButtonComponent,
  IconCardButtonComponent,
} from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-how-to-questionnaire-option',
  templateUrl: './how-to-questionnaire-option.component.html',
  styleUrls: [
    './how-to-questionnaire-option.component.ed.scss',
    './how-to-questionnaire-option.component.essent.scss',
  ],
  standalone: true,
  imports: [ImageCardButtonComponent, IconCardButtonComponent, ScIconPipe],
})
export class HowToQuestionnaireOptionComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;

  @Output() selected: EventEmitter<string> = new EventEmitter();

  breakpointMd = true;

  get title(): string {
    return getFieldValue<string>(this.rendering, 'Title', '');
  }

  get image(): ImageField {
    return getFieldValue<ImageField>(this.rendering, 'Image', {});
  }

  get nextQuestion(): InnogyComponentRendering | undefined {
    return getDropTreeValue<InnogyComponentRendering>(
      this.rendering?.fields,
      'NextQuestion'
    );
  }

  get icon(): InnogyComponentRendering | undefined {
    return this.rendering?.fields?.['Icon'] as
      | InnogyComponentRendering
      | undefined;
  }

  onSelect() {
    this.selected.emit(
      (this.nextQuestion as InnogyComponentRendering & { id: string })?.id
    );
  }
}
